<template>
  <v-container>
    <h3>対象者・協力者</h3>
    <v-btn color="cyan" class="white--text" @click="openAggregateSurveys">
      <v-icon color="white">open_in_browser</v-icon>集計ページを開く
    </v-btn>
    <v-btn color="cyan" class="white--text" @click="openAllResults">
      <v-icon color="white">open_in_browser</v-icon>全ての印刷ページを開く
    </v-btn>
    <v-data-table
      :items="subjects"
      :headers="headers"
      class="elevation-1"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      rows-per-page-text="表示行"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.item.subject_name}}</td>
          <td>{{props.item.job}}</td>
          <td>{{props.item.position}}</td>
          <td>
            <v-btn small @click.stop="toResultUrl(props.item.subject_id)">結果確認</v-btn>
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
    </v-data-table>
  </v-container>
</template>
<script>
import db from "@/components/firebaseInit";
import EditUser from "@/components/manage_survey/editUser.vue";
import {
  getUnixtime,
  unixtimeToJapaneseFormattedDate
} from "@/utils/datetime.js";
import XLSX from "xlsx";
import { mapMutations, mapGetters } from "vuex";

export default {
  components: { EditUser },
  props: {
    answerItems: {}
  },
  data() {
    return {
      items: [],
      users: [],
      headers: [
        { text: "対象者名", value: "subject_name", sortable: true },
        { text: "対象者職種", value: "job", sortable: false },
        { text: "対象者役職", value: "position", sortable: false },
        { text: "操作", sortable: false }
      ],
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets"),
      showDialog: false,
      rowsPerPageItems: [25, 50, 100],
      pagination: {
        rowsPerPage: 25
      }
    };
  },
  computed: {
    subjects() {
      return this.answerItems.filter(ans => ans.type == "subject");
    },
    ...mapGetters("auth", ["auths"])
  },
  methods: {
    toResultUrl(id) {
      let routeData = this.$router.resolve({
        name: "print_result",
        params: {
          company_id: this.$route.params.company_id,
          survey_id: this.$route.params.survey_id,
          user_id: id
        }
      });
      window.open(routeData.href, "_blank");
    },
    openAllResults() {
      this.subjects.forEach(s => {
        let routeData = this.$router.resolve({
          name: "print_result",
          params: {
            company_id: this.$route.params.company_id,
            survey_id: this.$route.params.survey_id,
            user_id: s.subject_id
          }
        });
        window.open(routeData.href, "_blank");
      });
    },
    openAggregateSurveys(){
      const routerData = this.$router.resolve({
        name: "aggregate_surveys",
        params: {
          company_id: this.$route.params.company_id,
          survey_id: this.$route.params.survey_id
        }
      });
      window.open(routerData.href, "_blank");
    },

    ...mapMutations("app", ["changeLoadingState"])
  }
};
</script>

<style lang="scss" scoped>

.line-break{ word-wrap: break-all; }

</style>
